import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import Table from "../../components/Table";
import { viewNews, deleteNews } from "../../../states/actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Avatar } from "@mui/material";
import Layout from "../layout/Layout";
import Loading from "../loading/Loading";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const ViewBlogs = () => {
  // dispatch
  const dispatch = useDispatch();

  // hooks
  const blogs = useSelector((state) => state.blogs);
  // use effect
  useEffect(() => {
    dispatch(viewNews());
  }, []);

  const navigate = useNavigate();

  const handleUpdateNews = (data) => {
    navigate("/update-news/" + data.id);
  };

  function handleRemoveNews(data) {
    if (
      window.confirm(
        "Data deleted permantly. Are you sure to delete completely!",
      )
    ) {
      dispatch(deleteNews(data.id));
    }
    setTimeout(function () {
      dispatch(viewNews());
    }, 1000);
  }
  const blogsColumns = [
    {
      accessorKey: "author", //access nested data with dot notation
      header: "Author Name",
    },

    {
      accessorKey: "title", //access nested data with dot notation
      header: "Title",
    },

    {
      accessorKey: "description", //access nested data with dot notation
      header: "Description",
    },
    {
      accessorKey: "photo", //access nested data with dot notation
      header: "Images",
      size: 100,
      Cell: ({ cell }) => (
        <div>
          <Avatar
            src={`${BaseUrl}${cell.getValue()}`.replace(/([^:]\/)\/+/g, "$1")}
            // sx={{ width: 100, height: 100 }}
            variant="rounded"
          />
        </div>
      ),
    },
  ];
  const { t: translate } = useTranslation(["blogs"]);
  return (
    <Layout title={"News"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography variant="h6">{translate("All News")}</Typography>

          <Link to="/add-news" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              sx={{ borderRadius: "5px" }}
            >
              {translate("Add News")}
            </Button>
          </Link>
        </Box>
        {blogs?.News ? (
          <Table
            data={blogs?.News}
            fields={blogsColumns}
            numberOfRows={blogs?.News?.length}
            enableTopToolBar={true}
            enableBottomToolBar={true}
            enablePagination={true}
            enableRowSelection={true}
            enableColumnFilters={true}
            enableEditing={true}
            enableColumnDragging={true}
            showPreview={true}
            deleteFunction={handleRemoveNews}
            upDatefunction={handleUpdateNews}
          />
        ) : (
          <Loading />
        )}
      </Box>
      <ToastContainer />
    </Layout>
  );
};

export default ViewBlogs;
